import * as _ from "lodash";

import * as SmartDrawings from "../../smartDrawings";

type Rgb = number[];
type Limits = { low: SmartDrawings.RangePoint, high: SmartDrawings.RangePoint };

const colorToRgbArray = (color: SmartDrawings.Color): Rgb => {
    return [color.r, color.g, color.b];
}

const getPoint = (d: number, a1: Rgb, a2: Rgb): Rgb => {
    // find a color d% between a1 and a2
    return a1.map((p, i) => Math.floor(a1[i] + d * (a2[i] - a1[i])));
}

const getLimits = (value: number, range: SmartDrawings.RangeColorScheme): Limits => {
    for (let i = 0; i < range.range.length; i++) {
        const low = range.range[i];
        const high = _.nth(range.range, i + 1);
        if (value >= low.value && (high == null || value < high.value)) {
            return { low: low, high: high };
        }
    }
    return null;
}

const getRgb = (value: number, range: SmartDrawings.RangeColorScheme, outdated: boolean = false): Rgb => {
    if (outdated) {
        return [0, 0, 0];
    }

    const limits = getLimits(value, range);
   
    if (limits != null) {
        const point = limits.high != null ? (value - limits.low.value) / (limits.high.value - limits.low.value) : limits.low.value;
        return getPoint(point, colorToRgbArray(limits.low.color), limits.high ? colorToRgbArray(limits.high.color) : colorToRgbArray(limits.low.color));
    } else {
        return [255, 255, 255];
    }
    
}

const getColorVector = (value: number, range: SmartDrawings.RangeColorScheme, outdated: boolean = false): THREE.Vector4 => {
    const rgb = getRgb(value, range, outdated);
  
    const c = new THREE.Color(`rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`);
    return new THREE.Vector4(c.r, c.g, c.b, 1);
}

const makeColorVector = (color: SmartDrawings.Color) => {
    const { r, g, b, a } = color;
    const c = new THREE.Color(`rgb(${r}, ${g}, ${b})`);
    return new THREE.Vector4(c.r, c.g, c.b, a);
}

export { getLimits, getRgb, getColorVector, makeColorVector };